import React, { useEffect, useState } from "react"
import { Clock, DollarSign, TrendingUp, Users, ArrowUp, ArrowDown, ThumbsUp, ThumbsDown, Euro, Eye } from "lucide-react"
import { Button, DatePicker, Select, Table, Drawer, message, Badge, Radio, TimePicker, notification, Modal, Input, Tooltip } from "antd"
import { EditOutlined, FilePdfOutlined, PlusOutlined, LoginOutlined, LogoutOutlined, ClockCircleOutlined, EyeOutlined, CaretRightOutlined, PauseOutlined } from "@ant-design/icons"
import moment from "moment"
import { FaEdit, FaEye } from 'react-icons/fa'
import { convertItalianToLocalTime, convertLocalToItalianTime, fetchEmployeeLog, fetchEmployeeName, getClockStatus, getTodayLogEntryTime, secondsToHMSLabel, timeToSeconds, verifyToken, updateFcmToken, convertToHoursMinutes } from "../../utils/helpers"
import { useDispatch, useSelector } from "react-redux"
import { translations, THEME_COLOR } from "../../utils/constants"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import LogEntry from "../LogEntry/LogEntry"
import ApplyLeave from "../ApplyLeaves/ApplyLeaves"
import { GET, POST } from "../../utils/apis"
import { secureApi } from "../../Config/api"
import useUserLocation from "../../Hooks/useUserLocation"
import { AddEmployeeWorkLogInAdmin, WorkTimerPopup } from "../../Components"
import { setNotificationFlag } from "../../Redux/actions/authActions"
import { socket } from "../../Config/socket"
import { Divider, Tag } from 'antd'
import { getFcmToken } from '../../Config/firebase'
import axios from "axios"

const { RangePicker } = DatePicker
const { Option } = Select

const Home = ({ language }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { TextArea } = Input;
  const { refetchLocation } = useUserLocation()

  const user = useSelector((state) => state.authReducer?.user)
  const user_id = user?.id
  const employeeData = useSelector((state) => state.employeeLogReducer.data)
  const clockStatus = getClockStatus(employeeData || [])
  const todayLogEntryTime = getTodayLogEntryTime(employeeData || [])
  const employeeSummaryData = useSelector((state) => state.employeeLogReducer.summary)
  const employeeNameList = useSelector((state) => state.employeeLogReducer.nameList)
  const showNotification = useSelector((state) => state.authReducer?.showNotification)
  const [viewRecord, setViewRecord] = useState({})
  const [showPopup, setShowPopup] = useState(false)
  const [breakDrawerOpen, setBreakDrawerOpen] = useState(false)
  const [isEditMode, setIsEditMode] = useState(false); // Default to false (add mode)
  const [selectedBreaks, setSelectedBreaks] = useState([])
  const [dateRange, setDateRange] = useState([
    moment().startOf("month"),
    moment()
  ]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [noteToEdit, setNoteToEdit] = useState('');
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [selectedOption, setSelectedOption] = useState([])
  const [drawerVisible, setDrawerVisible] = useState(false)
  const [leaveDrawerVisible, setLeaveDrawerVisible] = useState(false)
  const [adminCheckDrawer, setAdminCheckDrawer] = useState(false)
  const [adminAddWorkLogDrawer, setAdminAddWorkLogDrawer] = useState(false)
  const [selectedUserForCheckin, setSelectedUserForCheckin] = useState(null)
  const [timeOption, setTimeOption] = useState("system")
  const [manualTime, setManualTime] = useState(null)
  const [editRecord, setEditRecord] = useState(null)
  const [onBreak, setOnBreak] = useState(false)
  const [breakDrawer, setBreakDrawer] = useState(false)
  const [resumeDrawer, setResumeDrawer] = useState(false)
  const [employeeBreakStatus, setEmployeeBreakStatus] = useState({});
  const [disableButton, setDisableButton] = useState(false);
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0
  });

  // console.log('employeeData', employeeData)
  // console.log('breakDrawerOpen', breakDrawerOpen)
  // console.log('selectedBreaks', selectedBreaks)
  // console.log(showNotification, 'showNotification')

  // console.log('employeeData', employeeData)



  useEffect(() => {
    verifyToken(history, dispatch)
    fetchEmployeeName({ dispatch, user })

    getToken()
  }, [])

  useEffect(() => {
    socket.on("employeeLogs:changed", (payload) => {
      console.log("Realtime payload:", payload);
      if (user?.role === "user") {
        if (payload?.user_id === user?.id) {
          fetchLogs()
        }
      } else {
        fetchLogs()
      }
    });

    return () => {
      socket.off("employeeLogs:changed");
    };
  }, []);


  const getToken = async () => {
    const fcmToken = await getFcmToken()

    if (fcmToken) {
      updateFcmToken(user?.id, fcmToken)
    }
  }

  const fetchLogs = () => {
    fetchEmployeeLog({
      dispatch,
      dateRange,
      selectedOption,
      user,
      page: pagination.current,
      limit: pagination.pageSize
    });
  }

  useEffect(() => {
    fetchLogs()
  }, [pagination.current, pagination.pageSize, dateRange, selectedOption]);

  useEffect(() => {
    if (["admin", "teamTrack", "superAdmin"].includes(user?.role)) {
      setSelectedUserForCheckin({
        id: user?.id,
        user_name: user?.userName,
      })
    }
  }, [user])

  useEffect(() => {
    if (employeeSummaryData?.pagination) {
      setPagination(prev => ({
        ...prev,
        // current: employeeSummaryData.pagination.currentPage,
        total: employeeSummaryData.pagination.totalRecords
      }));
    }
  }, [employeeSummaryData]);


  // ✅ Keep onBreak status tied to the selected employee
  useEffect(() => {
    if (employeeData && employeeData.length > 0) {
      const currentStatus = viewRecord?.status
      if (currentStatus === "break") {
        setOnBreak(true)
      }
    } else {
      // fallback: check the logged-in user's record
      const selfRecord = employeeData.find(emp => emp.user_id === user?.id);
      if (selfRecord?.status === "break") {
        setOnBreak(true);
      } else {
        setOnBreak(false);
      }
    }
  }, [viewRecord])

  useEffect(() => {
    if (!employeeData || employeeData?.length === 0) return;

    // Find today's log for the logged-in user
    const selfRecord = employeeData.find(emp => emp?.user_id === user?.id);

    if (selfRecord?.status === "break") {
      setOnBreak(true);
    } else {
      setOnBreak(false);
    }
  }, [employeeData, user?.id]);

  if (showNotification) {
    notification.open({
      key: "testing-phase",
      message: translations[language]?.testingPhaseTitle,
      description: (
        <div style={{ lineHeight: 1.6 }}>
          {translations[language]?.testingPhaseMsg}
        </div>
      ),
      placement: "topRight",
      duration: 0,
      style: {
        marginTop: 80,
        width: 400,
        backgroundColor: "#f6ffed",
        border: "1px solid #b7eb8f",
        borderRadius: 8,
      },
      onClose: () => {
        dispatch(setNotificationFlag(false))

      },
    })
  }

  const disabledFutureDates = (current) => current && current > moment().endOf("day")

  const formatCurrency = (value) => {
    const numericValue = isNaN(parseFloat(value)) ? 0 : parseFloat(value)

    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
    }).format(numericValue)
  }

  const isTodayInRange = () => {
    const today = moment()
    return (
      today.isSameOrAfter(dateRange[0], "day") &&
      today.isSameOrBefore(dateRange[1], "day")
    )
  }

  const handleExport = async (user) => {
    try {

      // console.log(params, 'params')
      const response = await axios.get(GET.GET_EMPLOYEE_PDF, {
        params: {
          role: user?.role,
          user_id: user?.id,
          selectedOption,
          dateRange: {
            start: dateRange?.[0]?.format('YYYY-MM-DD'),
            end: dateRange?.[1]?.format('YYYY-MM-DD')
          },
          language
        },
        responseType: "blob",
      })
      console.log(response, 'response')
      const contentType = response.headers["content-type"]

      if (contentType !== "application/pdf") {
        const reader = new FileReader()
        reader.onload = () => {
          message.error("Server returned non-PDF response: " + reader.result, 5)
        }
        reader.readAsText(response.data)
        return
      }

      const blob = new Blob([response.data], { type: "application/pdf" })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = url
      link.setAttribute("download", "EmployeeReport.pdf")
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)

      message.success(translations[language]?.employeeReportDownload, 3)
    } catch (error) {
      console.error("PDF Export Error:", error);
      message.error(translations[language]?.employeeReportDownloadFailed, 5)
    }
  }


  const TrendIndicator = ({ trend, isPositive }) => (
    <div
      className={`trend-indicator ${isPositive ? "positive" : "negative"}`}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 4,
        color: isPositive ? "#28a745" : "#dc3545",
        fontWeight: 500
      }}
    >
      {isPositive ? <ArrowUp size={14} /> : <ArrowDown size={14} />}
      <span>{Math.abs(trend)}%</span>
    </div>
  )

  const indicators = employeeSummaryData?.indicators || {}

  const dashboardCards = [
    {
      title: translations[language].totalHours,
      value: convertToHoursMinutes(employeeSummaryData?.totalHours || 0),
      icon: <div className="total-hours"><Clock className="card-icon" /></div>,
      trend: { value: indicators.hoursTrend || 0, isPositive: (indicators.hoursTrend || 0) >= 0 },
      period: translations[language].thisMonth
    },
    {
      title: translations[language]?.totalExpenses,
      value: formatCurrency(employeeSummaryData?.totalDayTotal || 0),
      icon: <div className="total-expenses"><Euro className="card-icon" /></div>,
      trend: { value: indicators.expensesTrend || 0, isPositive: (indicators.expensesTrend || 0) >= 0 },
      period: translations[language]?.thisMonth
    },
    {
      title: translations[language].overtime,
      // value: `${Number(employeeSummaryData?.totalOvertime || 0).toFixed(2)} ${translations[language]?.hrs}`,
      value: convertToHoursMinutes(employeeSummaryData?.totalOvertime || 0),
      icon: <div className="daily-average"><Clock className="card-icon" /></div>,
      trend: { value: indicators.overtimeTrend || 0, isPositive: (indicators.overtimeTrend || 0) >= 0 },
      period: translations[language].last30Days
    },
    {
      title: translations[language].totalKm,
      value: `${employeeSummaryData?.totalKm || 0} km`,
      icon: <div className="extra-shifts"><Users className="card-icon" /></div>,
      trend: { value: indicators.kmTrend || 0, isPositive: (indicators.kmTrend || 0) >= 0 },
      period: translations[language].thisMonth
    }
  ]

  const handleViewTimer = (record) => {
    setViewRecord(record)
    setShowPopup(true)
  }

  const handleLogAdded = () => {
    setDrawerVisible(false)
    setShowPopup(false)
    setEditRecord(null)
    fetchEmployeeLog({ dispatch, dateRange, selectedOption, user })
  }

  const handleUserCheckIn = async (targetUserId, targetUserName, customStart) => {
    try {
      setLoading(true)
      const { ip, lat, lon } = await refetchLocation();
      const now = moment()
      const localTime = customStart ? moment(customStart, "HH:mm:ss") : now
      const italianMoment = convertLocalToItalianTime(localTime)
      const italyDate = italianMoment.tz("Europe/Rome").format("YYYY-MM-DD")
      const startItalian = italianMoment.format("HH:mm:ss")
      const payload = {
        user_id: targetUserId,
        employeeName: targetUserName,
        workDate: italyDate,
        startTime: startItalian,
        ip, lat, lon
      }

      const response = await secureApi.post(POST?.CHECK_IN, payload)
      if (response?.success) {
        message.success("Checked in successfully!")
        fetchEmployeeLog({ dispatch, dateRange, selectedOption, user })
        setAdminCheckDrawer(false)
        setManualTime(null)
      } else {
        message.error(response?.message || "Failed to check in")
      }
    } catch (error) {
      console.error("Check-in Error:", error)
      message.error("Error occurred while checking in")
    }
    finally {
      setLoading(false)
    }
  }

  const handleStartBreak = async (targetUserId = user_id, isAdmin = false) => {
    try {
      setDisableButton(true)
      const now = moment()
      const localTime =
        (["admin", "teamTrack", "superAdmin"].includes(user?.role) && timeOption === "manual" && manualTime)
          ? moment(manualTime, "HH:mm")
          : now;

      // 🔹 Convert local to Italian properly
      const italianMoment = convertLocalToItalianTime(localTime);
      const italyDate = italianMoment.tz("Europe/Rome").format("YYYY-MM-DD");
      const startItalian = italianMoment.format("HH:mm:ss");

      const selectedEmployeeLog = employeeData.find(
        (log) => log.user_id === targetUserId
      );


      if (!selectedEmployeeLog)
        if (!selectedEmployeeLog) {
          setDisableButton(false)
          setBreakDrawer(false)
          // message.error("No matching employee log found for this user.");
          return;
        }

      // 🟢 payload same structure as check-in
      const payload = {
        user_id: targetUserId,
        day_id: selectedEmployeeLog.id,
        role: user?.role,
        workDate: italyDate,
        start_time: startItalian,
      };

      // console.log("🚀 BREAK PAYLOAD:", payload); // debug log

      const response = await secureApi.post(POST?.BREAK_TIME, payload);
      setDisableButton(false)

      if (response?.success) {
        message.success(translations[language]?.BreakStartedSuccessfully);
        setEmployeeBreakStatus((prev) => ({ ...prev, [targetUserId]: true }));
        setOnBreak(true);
        setBreakDrawer(false);
        fetchEmployeeLog({ dispatch, dateRange, selectedOption, user });
      }
      else {
        message.error(response?.message || "Failed to start break");
      }
    }
    catch (error) {
      console.error("Break Error:", error);
      message.error("Error while starting break");
    }
  }

  const handleResumeWork = async (targetUserId = user_id, isAdmin = false) => {
    try {
      const selectedEmployeeLog = employeeData.find(
        (log) => log?.user_id === targetUserId
      )

      if (!selectedEmployeeLog) {
        setResumeDrawer(false)
        // message.error("No matching employee log found for this user.")
        return
      }

      const lastBreak = selectedEmployeeLog?.breaks?.slice(-1)[0]
      if (!lastBreak?.id) {
        setResumeDrawer(false)
        // message.error("No active break found for this user.")
        return
      }

      const now = moment()
      const localTime =
        (["admin", "teamTrack", "superAdmin"].includes(user?.role) && timeOption === "manual" && manualTime)
          ? moment(manualTime, "HH:mm")
          : now;


      const italianMoment = convertLocalToItalianTime(localTime)
      const italyDate = italianMoment.tz("Europe/Rome").format("YYYY-MM-DD")
      const endItalian = italianMoment.format("HH:mm:ss")

      const payload = {
        user_id: targetUserId,
        day_id: selectedEmployeeLog?.id,
        break_id: lastBreak?.id,
        role: user?.role,
        workDate: italyDate,
        end_time: endItalian,
      }

      const response = await secureApi.post(POST?.RESUME_WORK, payload)
      // console.log("🚀 RESUME PAYLOAD:", payload); // debug log
      if (response?.success) {
        message.success(translations[language]?.WorkResumedSuccessfully)
        setEmployeeBreakStatus((prev) => ({ ...prev, [targetUserId]: false }))
        setOnBreak(false)
        setResumeDrawer(false)
        fetchEmployeeLog({ dispatch, dateRange, selectedOption, user })
      } else {
        message.error(response?.message || "Failed to resume work")
      }
    } catch (error) {
      console.error("Resume Error:", error)
      message.error("Error while resuming work")
    }
  }

  const handleCheckInClick = () => {
    const role = user?.role;

    if (role === 'user' || role === 'qualityUser') {
      handleUserCheckIn(user_id, user?.userName);
    } else {
      setAdminCheckDrawer(true);
    }
  };


  const handleAddWorkLog = () => {
    setAdminAddWorkLogDrawer(true)
  }

  const handleEdit = (record) => {
    setEditRecord(record)
    setDrawerVisible(true)
  }

  const handleEditNotes = (record) => {
    setSelectedRecord(record);  // Save the record that the user wants to edit
    setNoteToEdit(record?.notes || '');  // Pre-fill the text area with the existing note
    setIsEditMode(true);  // Set to edit mode
    setIsModalVisible(true); // Open the modal
  };


  const handleSaveNotes = async () => {
    try {
      const payload = {
        userId: selectedRecord?.user_id,
        logId: selectedRecord?.id,
        notes: noteToEdit,  // The note that the user has added/edited
      };

      if (isEditMode) {
        // If in edit mode, make an API call to update the note
        const response = await secureApi.post(POST?.UPDATE_NOTE, payload);  // Update Note API

        if (response?.success) {
          message.success("Notes updated successfully!");
        } else {
          message.error(response?.message || "Failed to update notes");
        }
      } else {
        // If in add mode, make an API call to add the note
        const response = await secureApi.post(POST?.ADD_NOTE, payload);  // Add Note API

        if (response?.success) {
          message.success("Notes added successfully!");
        } else {
          message.error(response?.message || "Failed to add notes");
        }
      }

      // Close the modal after successfully saving the note
      setIsModalVisible(false);  // Close the modal
      setNoteToEdit('');  // Reset the note content

      // Optionally, refetch the logs or update the state after saving
      fetchLogs();  // Call function to fetch updated logs, or update the local state if needed
    } catch (error) {
      message.error("Error occurred while saving notes");
      console.error("Error saving notes:", error);
    }
  };


  const isToday = (recordDate) => {
    if (!recordDate) return false;

    const today = new Date().toLocaleDateString('en-CA');

    const formattedRecordDate = new Date(recordDate).toLocaleDateString('en-CA');

    return today === formattedRecordDate;
  }

  const columns = [
    {
      title: translations[language].WorkDay,
      dataIndex: 'work_day',
      key: 'work_day',
      render: (date) => moment(date).format('DD/MM/YYYY'),
      summaryRender: () => <strong>{translations[language].total}</strong>
    },
    {
      title: translations[language].status,
      dataIndex: 'status',
      key: 'status',
      render: (status, record) => {
        let badgeStatus = 'default'
        let badgeText = status

        if (status === 'completed') {
          badgeStatus = 'success'
          badgeText = translations[language].completed
        }
        else if (status === 'working') {
          badgeStatus = 'processing'
          badgeText = translations[language].working
        }
        else if (status === 'missed') {
          badgeStatus = 'error'
          badgeText = translations[language].missed
        } else if (status === 'break') {
          badgeStatus = 'warning'
          badgeText = translations[language].break
        } else if (status === 'resume') {
          badgeStatus = 'success'
          badgeText = translations[language].resume
        }


        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              lineHeight: "1.2",
            }}
          >
            <Button
              type="link"
              icon={<FaEye size={15} style={{ verticalAlign: "-2px" }} />}
              onClick={() => handleViewTimer(record)}
              style={{
                padding: 0,
                height: "auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            />
            <Badge
              status={badgeStatus}
              text={badgeText}
              style={{ display: "flex", alignItems: "center" }}
            />
          </div>
        )
      },
      summaryRender: () => "-"
    },


    ...(user?.role !== "user"
      ? [{
        title: translations[language].employee,
        dataIndex: 'employee_name',
        key: 'employee_name',
        render: (_, record) => `${record?.employee_name || '-'}`,
        summaryRender: () => "-"
      }]
      : []),
    {
      title: translations[language].workingHours,
      key: 'workingHours',
      render: (_, record) => {


        if (!record?.entry_time) {
          return '--';
        }
        const entryMoment = convertItalianToLocalTime(record.entry_time);

        const exitMoment = record.exit_time ? convertItalianToLocalTime(record.exit_time) : moment()
        if (!entryMoment || !entryMoment.isValid()) {
          return '--'
        }
        const calcTotalBreakSeconds = (breaks) => {
          if (!Array.isArray(breaks)) {
            return 0;
          }
          let total = 0;
          breaks.forEach((b, idx) => {
            if (!b.start_time) {
              return;
            }

            const start = convertItalianToLocalTime(b.start_time);
            const end = b.end_time
              ? convertItalianToLocalTime(b.end_time)
              : moment();
            if (!start.isValid() || !end.isValid()) {
              return;
            }

            if (start.isBefore(entryMoment)) {
              return;
            }
            if (end.isAfter(exitMoment)) {
              return;
            }

            const duration = Math.max(0, end.diff(start, "seconds"));
            total += duration;
          });

          return total;
        };

        const totalBreakSeconds = calcTotalBreakSeconds(record.breaks);

        const diffSeconds = Math.max(
          0,
          exitMoment.diff(entryMoment, 'seconds') - totalBreakSeconds
        )

        const h = Math.floor(diffSeconds / 3600);
        const m = Math.floor((diffSeconds % 3600) / 60);

        const localEntry = entryMoment.format('HH:mm');
        const localExit = record.exit_time
          ? exitMoment.format('HH:mm')
          : moment().format('HH:mm');

        return `${localEntry} - ${localExit} (${h}h ${m}m ${translations[language]?.worked})`;
      },
      summaryRender: () => {
        const t_hr = convertToHoursMinutes(employeeSummaryData?.totalHours || 0)
        return `${t_hr}`
      },
    },
    {
      title: translations[language].breaks,
      dataIndex: 'breaks',
      key: 'breaks',
      align: 'center',
      render: (val) => (val?.length || 0),
      summaryRender: () => `-`
    },
    {
      title: translations[language].breakTime,
      dataIndex: 'breaks',
      key: 'breaks',
      align: 'center',
      render: (val = []) => {
        const totalSeconds = val?.reduce((sum, b) => {
          if (!b?.start_time || !b?.end_time) return sum
          return sum + (timeToSeconds(b.end_time) - timeToSeconds(b.start_time))
        }, 0)

        if (!totalSeconds) return '-'

        return (
          <span
            style={{ color: '#1677ff', cursor: 'pointer', fontWeight: 500 }}
            onClick={() => {
              setSelectedBreaks(val)
              setBreakDrawerOpen(true)
            }}
          >
            ({secondsToHMSLabel(totalSeconds)} {translations[language].break})
          </span>
        )
      },
      summaryRender: () => '-'
    },
    {
      title: translations[language].lunch,
      dataIndex: 'lunch',
      key: 'lunch',
      align: 'center',
      render: (value) => formatCurrency(value),
      summaryRender: () => formatCurrency(employeeSummaryData?.totalLunch)
    },
    {
      title: translations[language].dinner,
      dataIndex: 'dinner',
      key: 'dinner',
      align: 'center',
      render: (value) => formatCurrency(value),
      summaryRender: () => formatCurrency(employeeSummaryData?.totalDinner)
    },
    {
      title: translations[language].hotel,
      dataIndex: 'hotel_expense',
      key: 'hotel_expense',
      align: 'center',
      render: (value) => formatCurrency(value),
      summaryRender: () => formatCurrency(employeeSummaryData?.totalHotel)
    },
    {
      title: translations[language].Ferry,
      dataIndex: 'ferry_expense',
      key: 'ferry_expense',
      align: 'center',
      render: (value) => formatCurrency(value),
      summaryRender: () => formatCurrency(employeeSummaryData?.totalFerry)
    },
    {
      title: translations[language].Telepass,
      dataIndex: 'telepass',
      key: 'telepass',
      align: 'center',
      render: (value) => formatCurrency(value),
      summaryRender: () => formatCurrency(employeeSummaryData?.totalTelepass)
    },
    {
      title: 'KM',
      key: 'km_rate',
      align: 'center',
      render: (_, record) => {
        const kmRate = parseFloat(record.km_rate) || 0
        const kmTravelled = parseFloat(record.km_traveled) || 0
        const totalCost = kmRate * kmTravelled
        const formattedRate = formatCurrency(kmRate)
        const formattedCost = formatCurrency(totalCost)
        const formattedKm = kmTravelled.toFixed(2)
        return `${formattedCost} for ${formattedKm} km (@${formattedRate}/km)`
      },
      summaryRender: () => formatCurrency(employeeSummaryData?.totalKmCost)
    },
    {
      title: translations[language].travel,
      dataIndex: 'travel_expenses',
      key: 'travel_expenses',
      align: 'center',
      render: (value) => formatCurrency(value),
      summaryRender: () => formatCurrency(employeeSummaryData?.totalTravel)
    },
    {
      title: translations[language].overtime,
      dataIndex: 'overtime',
      key: 'overtime',
      align: 'center',
      render: (value) => convertToHoursMinutes(value),
      summaryRender: () => convertToHoursMinutes(employeeSummaryData?.totalOvertime)
    },
    {
      title: translations[language].extras,
      dataIndex: 'extra',
      key: 'extra',
      align: 'center',
      render: (value) => formatCurrency(value),
      summaryRender: () => formatCurrency(employeeSummaryData?.totalExtras)
    },
    {
      title: translations[language].dayTotal,
      key: 'day_total',
      align: 'center',
      dataIndex: 'day_total',
      render: (value) => formatCurrency(value),
      summaryRender: () => <strong>{formatCurrency(employeeSummaryData?.totalDayTotal)}</strong>
    },

    {
      title: translations[language].notes,

      dataIndex: "notes",
      key: "notes",
      render: (text, record) => {
        const today = isToday(record.work_day);
        const hasNotes = record?.notes?.trim();

        const shortNote =
          hasNotes && record.notes.length > 20
            ? record.notes.slice(0, 20) + "..."
            : record?.notes;

        return (
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            {today ? (
              <EditOutlined
                style={{ cursor: "pointer", color: "#1890ff" }}
                onClick={() => handleEditNotes(record)}
              />
            ) : (
              <EyeOutlined
                style={{ cursor: "pointer", color: "#52c41a" }}
                onClick={() => handleEditNotes(record)}
              />
            )}

            {/* TODAY */}
            {today ? (
              hasNotes ? (
                <Tooltip title={record.notes}>
                  <span
                    onClick={() => handleEditNotes(record)}
                    style={{
                      maxWidth: 120,
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      fontSize: 12,
                      color: "#555",
                      cursor: "pointer",
                    }}
                  >
                    {shortNote}
                  </span>
                </Tooltip>
              ) : (
                <span
                  onClick={() => handleEditNotes(record)}
                  style={{
                    fontSize: 12,
                    color: "#1890ff",
                    fontStyle: "italic",
                    cursor: "pointer",
                  }}
                >
                  {translations[language].norecordnots}</span>
              )
            ) : (
              /* PREVIOUS DAYS */
              hasNotes ? (
                <Tooltip title={record.notes}>
                  <span
                    style={{
                      maxWidth: 120,
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      fontSize: 12,
                      color: "#555",
                      cursor: "pointer",
                    }}
                  >
                    {shortNote}
                  </span>
                </Tooltip>
              ) : (
                <span
                  style={{
                    fontSize: 12,
                    color: "#bfbfbf",
                    fontStyle: "italic",
                  }}
                >
                  {translations[language].norecordnots}</span>

              )
            )}
          </div>
        );
      },
    },


    ...(user?.role !== "user"
      ? [{
        title: translations[language].action,
        key: "action",
        align: "center",
        render: (_, record) => (
          <EditOutlined onClick={() => handleEdit(record)} />
        ),
        summaryRender: () => "-"
      }]
      : [])
  ]



  return (
    <div className="home-container">
      <div className="home-header" style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: "1rem" }}>
        <div>
          <h1 className="timesheet-title">{translations[language].employeeDashboard}</h1>
          <p className="timesheet-subtitle">{translations[language].trackAnalyze}</p>
        </div>

        {user?.role !== 'user' && user?.role !== 'qualityUser' ?
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label style={{ marginBottom: 4 }}>{translations[language].dateRange}</label>
              <RangePicker
                value={dateRange}
                onChange={(dates) => setDateRange(dates)}
                disabledDate={disabledFutureDates}
                className="custom-picker home-date-picker"
                allowClear={false}
              />
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label style={{ marginBottom: 4 }}>{translations[language].employee}</label>
              <Select
                mode="multiple"
                value={selectedOption}
                placeholder={translations[language].selectEmployees}
                onChange={(value) => setSelectedOption(value)}
                style={{ width: 200 }}
                className='employee-select-dropdown-two'
              >
                {employeeNameList?.map((value, index) => (
                  <Option key={index} value={value?.user_name}>
                    {value?.user_name}
                  </Option>
                ))}
              </Select>
            </div>
            <div style={{ display: "inline-flex", alignItems: "flex-end" }}>
              <Button
                className={`dashboard-export`}
                type="primary"
                onClick={() => handleExport(user)}
                disabled={!employeeData || employeeData?.length === 0}
                icon={<FilePdfOutlined />}
              >
                {translations[language].exportPdf}
              </Button>
            </div>
          </div>
          :
          <div className="dashboard-range-export">
            <div className="dashboard-range-section">
              <label className="dashboard-date-label">{translations[language].dateRange}</label>
              <RangePicker
                value={dateRange}
                onChange={(dates) => setDateRange(dates)}
                disabledDate={disabledFutureDates}
                className="custom-picker"
                allowClear={false}
              />
            </div>

            <Button
              className="dashboard-export-icon mobile-class"
              type="primary"
              onClick={() => handleExport(user)}
              disabled={!employeeData || employeeData?.length === 0}
              icon={<FilePdfOutlined />}
            />

            <Button
              className="dashboard-export desktop-class"
              type="primary"
              onClick={() => handleExport(user)}
              disabled={!employeeData || employeeData?.length === 0}
              icon={<FilePdfOutlined />}
            >
              {translations[language].exportPdf}
            </Button>
          </div>}
      </div>

      <div className='home-card-div'>
        <div
          style={{
            display: "grid",
            gap: 16,
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
          }}
          className="dashboard-grid"
        >
          {dashboardCards.map((card, index) => (
            <div key={index} className="dashboard-card">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 8,
                }}
              >
                {card.icon}
                <TrendIndicator trend={card.trend.value} isPositive={card.trend.isPositive} />
              </div>
              <h3 style={{ margin: "8px 0", fontSize: "15px" }}>{card.title}</h3>
              <p style={{ fontSize: 18, fontWeight: 600 }}>{card.value}</p>
              <div style={{ marginTop: 8 }}>
                <span style={{ fontSize: 12, color: "#999" }}>{card.period}</span>
              </div>
            </div>
          ))}
        </div>
      </div>


      <div className="table-container home-card-div" >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', marginBottom: 16 }}>
          <div className="timesheet-header">
            <h2 className="table-title">{translations[language].timesheetRecords}</h2>
            <p className="timesheet-subtitle">{translations[language].detailedView}</p>
          </div>

          {(user?.role === 'user' || user?.role === 'qualityUser') && (
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }} className="dashboard-user-buttons">
              <Button className={`export-btn  ${clockStatus === 'show-clockout' ? 'leave-button' : 'leave-button-clockin'}`}
                type="primary" onClick={() => setLeaveDrawerVisible(true)} icon={<PlusOutlined />}>
                {translations[language]?.applyForLeave}
              </Button>

              {clockStatus === 'done' ?
                <Button
                  className={`export-btn entry-button`}
                  type="primary"
                  style={{ cursor: 'not-allowed' }}
                  icon={<ThumbsUp size={15} style={{ marginRight: 2 }} />}
                >
                  {translations[language]?.goodWorkedToday}
                </Button>
                : clockStatus === 'show-missed' ?
                  <Button
                    className={`export-btn entry-button`}
                    type="primary"
                    style={{ cursor: 'not-allowed' }}
                    icon={<ThumbsDown size={15} style={{ marginRight: 5, marginBottom: -4 }} />}
                  >
                    {translations[language].youHaveMissedCheckout}
                  </Button>
                  : clockStatus === 'show-clockin' ?
                    <Button
                      disabled={!isTodayInRange()}
                      className={`export-btn entry-button`}
                      type="primary"
                      onClick={handleCheckInClick}
                      icon={<LoginOutlined />}
                    >
                      {translations[language]?.checkIn}
                    </Button>
                    : clockStatus === 'show-clockout' ? (
                      <>
                        <Button
                          className={`export-btn break-pause-button`}
                          type="primary"
                          onClick={() => {
                            if (onBreak) {
                              handleResumeWork()
                            }
                            else {
                              handleStartBreak()
                            }
                          }}
                          icon={<ClockCircleOutlined />}
                        >
                          {onBreak
                            ? translations[language]?.resume
                            : translations[language]?.break}
                        </Button>

                        <Button
                          className={`export-btn break-pause-button`}
                          type="primary"
                          onClick={() => setDrawerVisible(true)}
                          icon={<LogoutOutlined />}
                        >
                          {translations[language]?.checkOut}
                        </Button>
                      </>
                    ) : null}

            </div>
          )}

          {(user?.role === "admin" || user?.role === "teamTrack" || user?.role === "superAdmin") && (
            <>
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }} className="dashboard-buttons">
                <Button
                  className={`export-btn`}
                  type="primary"
                  onClick={handleAddWorkLog}
                  icon={<PlusOutlined />}
                >
                  {translations?.[language]?.addUserWorkEntry}
                </Button>

                <Button
                  className={`export-btn`}
                  type="primary"
                  onClick={handleCheckInClick}
                  icon={<LoginOutlined />}
                >
                  {translations[language]?.checkIn}
                </Button>

                <Button
                  className={`export-btn`}
                  type="primary"
                  onClick={() => setDrawerVisible(true)}
                  icon={<LogoutOutlined />}
                >
                  {translations[language]?.checkOut}
                </Button>

                <Button
                  className={`export-btn`}
                  type="primary"
                  onClick={() => setBreakDrawer(true)}
                  icon={<ClockCircleOutlined />}
                >
                  {translations[language]?.break}
                </Button>

                <Button
                  className={`export-btn`}
                  type="primary"
                  onClick={() => setResumeDrawer(true)}
                  icon={<ClockCircleOutlined />}
                >
                  {translations[language]?.resume}
                </Button>
              </div>
              <div className="dashboard-two-buttons">
                <>
                  <Tooltip title={translations?.[language]?.addUserWorkEntry}>
                    <Button
                      className="export-btn"
                      type="primary"
                      onClick={handleAddWorkLog}
                      icon={<PlusOutlined />}
                    />
                  </Tooltip>

                  <Tooltip title={translations?.[language]?.checkIn}>
                    <Button
                      className="export-btn"
                      type="primary"
                      onClick={handleCheckInClick}
                      icon={<LoginOutlined />}
                    />
                  </Tooltip>

                  <Tooltip title={translations?.[language]?.checkOut}>
                    <Button
                      className="export-btn"
                      type="primary"
                      onClick={() => setDrawerVisible(true)}
                      icon={<LogoutOutlined />}
                    />
                  </Tooltip>

                  <Tooltip title={translations?.[language]?.break}>
                    <Button
                      className="export-btn"
                      type="primary"
                      onClick={() => setBreakDrawer(true)}
                      icon={<PauseOutlined />}
                    />
                  </Tooltip>

                  <Tooltip title={translations?.[language]?.resume}>
                    <Button
                      className="export-btn"
                      type="primary"
                      onClick={() => setResumeDrawer(true)}
                      icon={<CaretRightOutlined />}
                    />
                  </Tooltip>
                </>
              </div>
            </>
          )}

          {/* <div className={`btn-row ${user?.role === 'user' ? 'btn-row--user' : 'btn-row--admin'}`}>
            {user?.role === 'user' && (
              <Button className="export-btn home-btn" type="primary" onClick={() => setLeaveDrawerVisible(true)} icon={<PlusOutlined />}>
                {translations[language]?.applyForLeave}
              </Button>
            )}
            <Button className={`export-btn ${user?.role === 'user' ? 'home-btn' : ''}`} type="primary" onClick={handleCheckInClick} icon={<LoginOutlined />}>
              {translations[language]?.checkIn}
            </Button>
            <Button className={`export-btn ${user?.role === 'user' ? 'home-btn' : ''}`} type="primary" onClick={() => setDrawerVisible(true)} icon={<LogoutOutlined />}>
              {translations[language]?.checkOut}
            </Button>
            <Button className={`export-btn ${user?.role === 'user' ? 'home-btn2' : ''}`} type="primary" onClick={handleExport} icon={<FilePdfOutlined />} disabled={!employeeData || employeeData?.length === 0}>
              {translations[language]?.exportPdf}
            </Button>
          </div> */}

        </div>

        <Table
          columns={columns}
          dataSource={employeeData}
          size="medium"
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
            showSizeChanger: true,
            pageSizeOptions: ["5", "10", "20", "50"],
            onChange: (page, pageSize) => {
              setPagination({ ...pagination, current: page, pageSize })
            }
          }}
          scroll={{ x: 'max-content' }}
          summary={() => (
            <Table.Summary.Row>
              {columns?.map((col, idx) => (
                <Table.Summary.Cell key={idx} index={idx}>
                  {col.summaryRender ? col.summaryRender() : null}
                </Table.Summary.Cell>
              ))}
            </Table.Summary.Row>
          )}
        />
      </div>

      <Drawer
        title={editRecord ? translations[language].editEmployeeLog : translations[language].EmployeeSheet}
        width={720}
        onClose={() => { setDrawerVisible(false); setEditRecord(null) }}
        open={drawerVisible}
        destroyOnClose
        placement="right"
      >
        <LogEntry
          language={language}
          onSuccess={handleLogAdded}
          onCancel={() => { setDrawerVisible(false); setEditRecord(null) }}
          isEdit={!!editRecord}
          editData={editRecord}
        />
      </Drawer>

      <Drawer
        title={translations[language].applyForLeaveDrawer}
        width={720}
        onClose={() => setLeaveDrawerVisible(false)}
        open={leaveDrawerVisible}
        destroyOnClose
        placement="right"
      >
        <ApplyLeave language={language} onSuccess={() => setLeaveDrawerVisible(false)} onCancel={() => setLeaveDrawerVisible(false)} />
      </Drawer>


      <Drawer
        title={translations[language].addUserWorkEntry}
        width={720}
        onClose={() => setAdminAddWorkLogDrawer(false)}
        open={adminAddWorkLogDrawer}
        destroyOnClose
        placement="right"
      >
        <AddEmployeeWorkLogInAdmin language={language} onSuccess={() => { setAdminAddWorkLogDrawer(false), fetchLogs() }} onCancel={() => setAdminAddWorkLogDrawer(false)} />
      </Drawer>

      <Drawer
        title={translations[language].checkInEmployee}
        width={400}
        onClose={() => setAdminCheckDrawer(false)}
        open={adminCheckDrawer}
        destroyOnClose
        placement="right"
      >
        <div>
          <p style={{ marginBottom: 8 }}>{translations[language].selectEmployeeToCheckIn}</p>
          <Select
            className="checkin-employee-select"
            showSearch
            style={{ width: '100%', marginBottom: 16, borderRadius: 6, height: 40 }}
            placeholder={translations[language].selectEmployees}
            value={selectedUserForCheckin?.user_name || user?.userName}
            onChange={(val) => {
              const emp = employeeNameList.find(e => e.user_name === val)
              if (emp) {
                setSelectedUserForCheckin(emp)
              } else {
                setSelectedUserForCheckin({
                  id: user?.id,
                  user_name: val
                })
              }
            }}
          >
            {["admin", "teamTrack", "superAdmin"].includes(user?.role) && (
              <Option key="me" value={user?.userName}>
                Me
              </Option>
            )}

            {employeeNameList?.map((emp) => (
              <Option key={emp.id} value={emp.user_name}>
                {emp.user_name}
              </Option>
            ))}
          </Select>


          <Radio.Group
            style={{ marginBottom: 16, display: "flex", flexDirection: "row", gap: 16 }}
            value={timeOption}
            onChange={(e) => setTimeOption(e.target.value)}
          >
            <Radio value="system">{translations[language]?.currentTime}</Radio>
            <Radio value="manual">{translations[language].enterManualTime}</Radio>
          </Radio.Group>

          {timeOption === "manual" && (
            <>
              <p style={{ marginBottom: 8 }}>{translations[language].selectStartTime}</p>

              <TimePicker
                value={manualTime}
                onChange={(time) => setManualTime(time)}
                format="HH:mm"
                style={{ width: "100%", marginBottom: 16, borderRadius: 6, height: 40 }}
                disabledHours={() => {
                  const currentHour = moment().hour();
                  return [...Array(24).keys()].filter((h) => h > currentHour);
                }}
                disabledMinutes={(selectedHour) => {
                  const currentHour = moment().hour();
                  const currentMinute = moment().minute();

                  // If selecting the current hour, disable minutes in the future
                  if (selectedHour === currentHour) {
                    return [...Array(60).keys()].filter((m) => m > currentMinute);
                  }

                  return [];
                }}
              />
            </>
          )}

          <Button
            className="export-btn"
            type="primary"
            loading={loading}
            disabled={!selectedUserForCheckin}
            onClick={() => {
              const now = moment()
              const chosenTime =
                timeOption === "manual" && manualTime
                  ? manualTime.format("HH:mm:ss")
                  : now.format("HH:mm:ss")
              handleUserCheckIn(
                selectedUserForCheckin.id,
                selectedUserForCheckin.user_name,
                chosenTime
              )
            }}
          >
            {translations[language].confirmCheckIn}
          </Button>
        </div>
      </Drawer>

      {/* 🟡 Break Drawer */}
      <Drawer
        title={translations[language]?.startBreak || "Start Break"}
        width={400}
        onClose={() => setBreakDrawer(false)}
        open={breakDrawer}
        destroyOnClose
        placement="right"
      >
        <div>
          <p style={{ marginBottom: 8 }}>{translations[language]?.selectEmployeeToCheckIn}</p>
          <Select
            showSearch
            className="checkin-employee-select"
            style={{ width: "100%", marginBottom: 16 }}
            placeholder={translations[language].selectEmployees}
            value={selectedUserForCheckin?.user_name || user?.userName}
            onChange={(val) => {
              const emp = employeeNameList.find(e => e.user_name === val)
              if (emp) {
                setSelectedUserForCheckin(emp)
              } else {
                setSelectedUserForCheckin({
                  id: user?.id,
                  user_name: val
                })
              }
            }}
          >
            {["admin", "teamTrack", "superAdmin"].includes(user?.role) && (
              <Option key="me" value={user?.userName}>
                Me
              </Option>
            )}
            {employeeNameList?.map((emp) => (
              <Option key={emp.id} value={emp.user_name}>
                {emp.user_name}
              </Option>
            ))}
          </Select>

          <Radio.Group
            style={{ marginBottom: 16, display: "flex", flexDirection: "row", gap: 16 }}
            value={timeOption}
            onChange={(e) => setTimeOption(e.target.value)}
          >
            <Radio value="system">{translations[language]?.currentTime}</Radio>
            <Radio value="manual">{translations[language].enterManualTime}</Radio>
          </Radio.Group>

          {timeOption === "manual" && (
            <>
              <p style={{ marginBottom: 8 }}>{translations[language].selectStartTime}</p>
              <TimePicker
                value={manualTime}
                onChange={(time) => setManualTime(time)}
                format="HH:mm"
                style={{ width: "100%", marginBottom: 16, borderRadius: 6, height: 40 }}
                disabledTime={() => {
                  const now = moment()
                  const currentHour = now.hour()
                  const currentMinute = now.minute()

                  return {
                    disabledHours: () => {
                      const hours = []
                      for (let i = currentHour + 1; i < 24; i++) hours.push(i)
                      return hours
                    },
                    disabledMinutes: (selectedHour) => {
                      if (selectedHour === currentHour) {
                        const minutes = []
                        for (let i = currentMinute + 1; i < 60; i++) minutes.push(i)
                        return minutes
                      }
                      return []
                    },
                  }
                }}
              />

            </>
          )}

          <Button
            className="export-btn"
            type="primary"
            disabled={!selectedUserForCheckin}
            onClick={() =>
              handleStartBreak(selectedUserForCheckin.id, true)
            }
          >
            {translations[language]?.confirmBreak}
          </Button>
        </div>
      </Drawer>

      {/* 🟢 Resume Drawer */}
      <Drawer
        title={translations[language]?.resumeWork}
        width={400}
        onClose={() => setResumeDrawer(false)}
        open={resumeDrawer}
        destroyOnClose
        placement="right"
      >
        <div>
          <p style={{ marginBottom: 8 }}>{translations[language]?.selectEmployeeToCheckIn}</p>
          <Select
            showSearch
            style={{ width: "100%", marginBottom: 16 }}
            className="checkin-employee-select"
            placeholder={translations[language].selectEmployees}
            value={selectedUserForCheckin?.user_name || user?.userName}
            onChange={(val) => {
              const emp = employeeNameList.find(e => e.user_name === val)
              if (emp) {
                setSelectedUserForCheckin(emp)
              } else {
                setSelectedUserForCheckin({
                  id: user?.id,
                  user_name: val
                })
              }
            }}
          >
            {["admin", "teamTrack", "superAdmin"].includes(user?.role) && (
              <Option key="me" value={user?.userName}>
                Me
              </Option>
            )}
            {employeeNameList?.map((emp) => (
              <Option key={emp.id} value={emp.user_name}>
                {emp.user_name}
              </Option>
            ))}
          </Select>

          <Radio.Group
            style={{ marginBottom: 16, display: "flex", flexDirection: "row", gap: 16 }}
            value={timeOption}
            onChange={(e) => setTimeOption(e.target.value)}
          >
            <Radio value="system">{translations[language]?.currentTime}</Radio>
            <Radio value="manual">{translations[language].enterManualTime}</Radio>
          </Radio.Group>

          {timeOption === "manual" && (
            <>
              <p style={{ marginBottom: 8 }}>{translations[language].selectStartTime}</p>
              <TimePicker
                value={manualTime}
                onChange={(time) => setManualTime(time)}
                format="HH:mm"
                style={{ width: "100%", marginBottom: 16, borderRadius: 6, height: 40 }}
                disabledTime={() => {
                  const now = moment()
                  const currentHour = now.hour()
                  const currentMinute = now.minute()

                  return {
                    disabledHours: () => {
                      const hours = []
                      for (let i = currentHour + 1; i < 24; i++) hours.push(i)
                      return hours
                    },
                    disabledMinutes: (selectedHour) => {
                      if (selectedHour === currentHour) {
                        const minutes = []
                        for (let i = currentMinute + 1; i < 60; i++) minutes.push(i)
                        return minutes
                      }
                      return []
                    },
                  }
                }}
              />
            </>
          )}

          <Button
            className="export-btn"
            type="primary"
            disabled={!selectedUserForCheckin}
            onClick={() =>
              handleResumeWork(selectedUserForCheckin.id, true)
            }
          >
            {translations[language]?.confirmResume || "Confirm Resume"}
          </Button>
        </div>
      </Drawer>

      <Drawer
        title={translations[language]?.breakDetails || 'Break Details'}
        width={420}
        placement="right"
        onClose={() => setBreakDrawerOpen(false)}
        open={breakDrawerOpen}
        destroyOnClose
      >
        {selectedBreaks.map((b, index) => {
          if (!b.start_time || !b.end_time) return null

          const startLocal = convertItalianToLocalTime(b.start_time)
          const endLocal = convertItalianToLocalTime(b.end_time)
          const duration = timeToSeconds(b.end_time) - timeToSeconds(b.start_time)

          return (
            <div
              key={b.id || index}
              style={{
                padding: 14,
                marginBottom: 12,
                borderRadius: 8,
                background: '#fafafa',
                border: '1px solid #f0f0f0'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: 8
                }}
              >
                <strong>{translations[language]?.break} #{index + 1}</strong>
                <Tag color="red">
                  {secondsToHMSLabel(duration)}
                </Tag>
              </div>

              <div style={{ fontSize: 13, color: '#555' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <LoginOutlined />
                  <span>{translations[language].start}:</span>
                  <strong>{startLocal.format('HH:mm')}</strong>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <LogoutOutlined />
                  <span>{translations[language].end}:</span>
                  <strong>{endLocal.format('HH:mm')}</strong>
                </div>
              </div>
            </div>
          );
        })}

        <Divider />

        {/* TOTAL */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '12px 4px',
            fontSize: 16,
            fontWeight: 600
          }}
        >
          <span>{translations[language]?.totalBreakTime}</span>
          <span>
            {secondsToHMSLabel(
              selectedBreaks.reduce((sum, b) => {
                if (!b.start_time || !b.end_time) return sum;
                return sum + (timeToSeconds(b.end_time) - timeToSeconds(b.start_time));
              }, 0)
            )}
          </span>
        </div>
      </Drawer>

      <Modal
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', paddingBottom: '10px' }}>
            {isToday(selectedRecord?.work_day) ? <EditOutlined style={{ color: THEME }} /> : <EyeOutlined style={{ color: '#52c41a' }} />}
            <span style={{ fontWeight: 600 }}>
              {!isToday(selectedRecord?.work_day) ? translations[language]?.viewDaySummary : (selectedRecord?.notes ? translations[language]?.updateNotes : translations[language]?.addNotes)}
            </span>
          </div>
        }
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        destroyOnClose
        width={550}
        centered
        bodyStyle={{ padding: '24px' }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>

          <div style={{ backgroundColor: '#eeeeee', padding: '10px 15px', borderRadius: '6px', borderLeft: `4px solid ${THEME_COLOR}` }}>
            <p style={{ margin: 0, fontSize: '13px', color: THEME_COLOR }}>
              <strong>{translations[language]?.date}</strong>{' '}
              {selectedRecord?.work_day ? (
                (() => {
                  const d = new Date(selectedRecord.work_day);
                  const day = d.getDate();
                  const monthIndex = d.getMonth()
                  const year = d.getFullYear();

                  const monthNames = [
                    translations[language]?.january,
                    translations[language]?.february,
                    translations[language]?.march,
                    translations[language]?.april,
                    translations[language]?.may,
                    translations[language]?.june,
                    translations[language]?.july,
                    translations[language]?.august,
                    translations[language]?.september,
                    translations[language]?.october,
                    translations[language]?.november,
                    translations[language]?.december,
                  ];

                  const monthName = monthNames[monthIndex] || 'N/A';

                  return `${day} ${monthName} ${year}`;
                })()
              ) : (
                'N/A'
              )}
            </p>
          </div>

          {isToday(selectedRecord?.work_day) ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '8px' }}>
              <label style={{ fontWeight: 500, color: '#434343' }}>{translations[language]?.dailyremarks}</label>
              <TextArea
                value={noteToEdit}
                onChange={(e) => setNoteToEdit(e.target.value)}
                rows={5}
                // placeholder="Write down your tasks or any important updates for today..."
                placeholder={translations[language]?.writeDone}
                style={{
                  borderRadius: '8px',
                  padding: '12px',
                  boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.05)',
                  maxHeight: '200px',
                  overflowY: 'auto',
                }} />
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '8px' }}>
              <label style={{ fontWeight: 500, color: '#434343' }}>{translations[language]?.previousnotes}</label>
              <div style={{
                padding: '16px',
                backgroundColor: '#fafafa',
                borderRadius: '8px',
                minHeight: '120px',
                border: '1px dashed #d9d9d9',
                whiteSpace: 'pre-wrap',
                color: selectedRecord?.notes ? '#262626' : '#bfbfbf',
                fontStyle: selectedRecord?.notes ? 'normal' : 'italic'
              }}>
                {selectedRecord?.notes || translations[language]?.nonotes}
              </div>
            </div>
          )}

          {/* Footer Actions */}
          {isToday(selectedRecord?.work_day) && (
            <div style={{ marginTop: '8px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <Button onClick={() => setIsModalVisible(false)} style={{ borderRadius: '6px' }}>
                {translations[language]?.cancel}
              </Button>
              <Button
                type="primary"
                onClick={handleSaveNotes}
                disabled={!selectedRecord?.notes && !noteToEdit}
                style={{
                  borderRadius: '6px',
                  padding: '0 25px',
                  fontWeight: 500,
                  background: '#1890ff',
                }}
              >
                {selectedRecord?.notes ? translations[language]?.saveChanges : translations[language]?.submitnotes}
              </Button>
            </div>
          )}
        </div>
      </Modal>

      {showPopup && (
        <WorkTimerPopup
          open={showPopup}
          viewRecord={viewRecord}
          breaks={viewRecord?.breaks}
          entryTime={viewRecord?.entry_time}
          onClockOut={() => setDrawerVisible(true)}
          onClose={() => setShowPopup(false)}
          user={user}
          language={language}
        // onBreak={employeeBreakStatus[viewRecord?.user_id] || false}
        />
      )}
    </div>
  )
}

export default Home